import React from 'react'
import Style from './Header.css'
import Button from '../Button/Button'
import Wordmark from '../../assets/franke.png'

const Header = (props) => {
  return (
    <div className="header bg-color-arizona-blue">
      <header>
        <div className="container">
          <a
            href="https://frankehonors.arizona.edu/"
            className="logo-link"
            id="the-univeristy-of-arizona-header"
            rel="noopener"
            target="_blank"
          >
            <img src={Wordmark} width="211" height="21" alt="The University od Arizona" />
          </a>
          <div className="header-button-wrap text-white">
            <Button
              linkId="apply-header"
              className="border-white "
              link="https://slate.admissions.arizona.edu/apply/?_gl=1*1g3vdo9*_ga*Mzc1NjE3MjA4LjE2OTU0MDk1NTA.*_ga_7PV3540XS3*MTcxMjg2NDY4Ny4zNTQuMS4xNzEyODY1MjE4LjYwLjAuMA.."
            >
              Apply Now
            </Button>
          </div>
        </div>
      </header>
    </div>
  )
}

export default Header
